import { GigCategory, GigPreview } from '../../shared/types';

export const GIG_CARDS_MAX_LIMIT = 6;

export const GIG_CATEGORIES: GigCategory[] = [
    {
        name: 'mobile_app_development',
        labelTranslationKey: 'popular_services.categories.mobile_app_development',
        link: '/categories/programming-tech/mobile-app-services',
    },
    {
        name: 'presentation_design',
        labelTranslationKey: 'popular_services.categories.presentation_design',
        link: '/categories/graphics-design/presentations-design',
    },
    {
        name: 'software_development',
        labelTranslationKey: 'popular_services.categories.software_development',
        link: '/categories/programming-tech/software-development',
    },
    {
        name: 'website_design',
        labelTranslationKey: 'popular_services.categories.website_design',
        link: '/categories/graphics-design/website-design',
    },
    {
        name: 'book_design',
        labelTranslationKey: 'popular_services.categories.book_design',
        link: '/categories/graphics-design/book-design',
    },
    {
        name: 'ai_development',
        labelTranslationKey: 'popular_services.categories.ai_development',
        link: '/categories/programming-tech/chatbots',
    },
    {
        name: 'ugc_videos',
        labelTranslationKey: 'popular_services.categories.ugc_videos',
        link: '/categories/video-animation/ugc-videos',
    },
    {
        name: 'resume_writing',
        labelTranslationKey: 'popular_services.categories.resume_writing',
        link: '/categories/writing-translation/resume-writing',
    },
];

export const GIG_CATEGORIES_V16: GigCategory[] = [
    {
        name: 'book_design',
        labelTranslationKey: 'popular_services_v16.categories.book_design',
        link: '/categories/graphics-design/book-design',
    },
    {
        name: 'architecture_interior_design',
        labelTranslationKey: 'popular_services_v16.categories.architecture_interior_design',
        link: '/categories/graphics-design/architectural-design-services',
    },
    {
        name: 'mobile_app_development',
        labelTranslationKey: 'popular_services_v16.categories.mobile_app_development',
        link: '/categories/programming-tech/mobile-app-services',
    },
    {
        name: 'presentation_design',
        labelTranslationKey: 'popular_services_v16.categories.presentation_design',
        link: '/categories/graphics-design/presentations-design',
    },
    {
        name: 'website_design',
        labelTranslationKey: 'popular_services_v16.categories.website_design',
        link: '/categories/graphics-design/website-design',
    },
    {
        name: 'ugc_videos',
        labelTranslationKey: 'popular_services_v16.categories.ugc_videos',
        link: '/categories/video-animation/ugc-videos',
    },
    {
        name: 'ai_development',
        labelTranslationKey: 'popular_services_v16.categories.ai_development',
        link: '/categories/programming-tech/chatbots',
    },
    {
        name: 'software_development',
        labelTranslationKey: 'popular_services_v16.categories.software_development',
        link: '/categories/programming-tech/software-development',
    },
    {
        name: 'resume_writing',
        labelTranslationKey: 'popular_services_v16.categories.resume_writing',
        link: '/categories/writing-translation/resume-writing',
    },
];

export const GIG_PREVIEWS: GigPreview[] = [
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206082/mobile-app-development-blinix-sol-1.png',
        userName: 'Blinix Sol',
        rating: 5,
        reviewsCount: 15,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/shamroz_rana/build-android-ios-or-cross-platform-app-using-react-native',
        sellerLink: '/agencies/blinixsolutions',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e2758e2f36eaa9415647ba520d34db6a-1753090682910/mobile-app-development-1.png',
        categoryName: 'mobile_app_development',
        gigDescription: 'Our agency will do mobile app development, android and ios app development',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206079/mobile-app-development-zack-logic-2.png',
        userName: 'Zack Logic',
        rating: 5,
        reviewsCount: 6,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/zack_logic/create-a-powerful-social-chat-app-social-media-platform-like-facebook',
        sellerLink: '/zack_logic',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e2758e2f36eaa9415647ba520d34db6a-1753090682928/mobile-app-development-2a.png',
        categoryName: 'mobile_app_development',
        gigDescription: 'I will create a powerful social chat app, social media platform like facebook',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206079/mobile-app-development-nilesh-3.png',
        userName: 'Nilesh',
        rating: 5,
        reviewsCount: 1200,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/ioslover/convert-your-app-in-ios-7',
        sellerLink: '/ioslover',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e2758e2f36eaa9415647ba520d34db6a-1753090682912/mobile-app-development-3a.png',
        categoryName: 'mobile_app_development',
        gigDescription: 'I will do development and design for android and iphone application',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206081/mobile-app-development-harminder-s-4.png',
        userName: 'Harminder S',
        rating: 5,
        reviewsCount: 658,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/micmed/be-your-mobile-app-developer-to-develop-android-ios-mobile-app',
        sellerLink: '/micmed',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e2758e2f36eaa9415647ba520d34db6a-1753090689591/mobile-app-development-4a.png',
        categoryName: 'mobile_app_development',
        gigDescription: 'I will do mobile app development create app development as flutter mobile app developer',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206066/mobile-app-development-alcax-solutions-5.png',
        userName: 'Alcax Solutions',
        rating: 5,
        reviewsCount: 426,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/alcaxsolutions/develop-a-high-quality-native-ios-and-android-mobile-app',
        sellerLink: '/agencies/alcax',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e2758e2f36eaa9415647ba520d34db6a-1753090689590/mobile-app-development-5a.png',
        categoryName: 'mobile_app_development',
        gigDescription:
            'Our agency will do mobile app development, app creation, app development as mobile app developer',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206080/mobile-app-development-ashish-mulani-6.png',
        userName: 'Ashish Mulani',
        rating: 5,
        reviewsCount: 362,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/nine_square/be-ios-app-developer-for-iphone-app-and-android-mobile-app-development',
        sellerLink: '/nine_square',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e2758e2f36eaa9415647ba520d34db6a-1753090689598/mobile-app-development-6a.png',
        categoryName: 'mobile_app_development',
        gigDescription: 'I will do mobile app development for android and ios app creation mobile app developer',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206064/presentation-design-emiliya-1.png',
        userName: 'Emiliya',
        rating: 4.9,
        reviewsCount: 887,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/emiliyashender/design-powerpoint-template-you-can-edit-very-easily',
        sellerLink: '/emiliyashender',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795757/presentation-design-1a.png',
        categoryName: 'presentation_design',
        gigDescription: 'I will create powerpoint presentation pitch deck design',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206065/presentation-design-slide-side-2.png',
        userName: 'Slide Side',
        rating: 4.9,
        reviewsCount: 17,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/kouroshdb/design-a-modern-investor-pitch-deck',
        sellerLink: '/agencies/DoConcept',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795752/presentation-design-2a.png',
        categoryName: 'presentation_design',
        gigDescription: 'Our agency will design a modern template and investor pitch deck',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7274e19167edb87185b25939efc6ae5c-1753262798445/presentation-design-shah-een-3.png',
        userName: 'Shah Een',
        rating: 4.9,
        reviewsCount: 591,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink: '/masteroflogos/design-wow-pitch-deck-presentation-for-you',
        sellerLink: '/masteroflogos',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795776/presentation-design-3a.png',
        categoryName: 'presentation_design',
        gigDescription: 'I will design pro investor pitch deck, startup presentation, business plan and slides',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206072/presentation-design-ada-m-4.png',
        userName: 'Ada M',
        rating: 4.9,
        reviewsCount: 180,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/adamazurek/design-crypto-nfts-futuristic-presentation-pitch-deck',
        sellerLink: '/adamazurek',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795752/presentation-design-4a.png',
        categoryName: 'presentation_design',
        gigDescription: 'I will design presentation pitch deck google slides, figma or canva',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206081/presentation-design-daria-novikova-5.png',
        userName: 'Daria Novikova',
        rating: 4.9,
        reviewsCount: 72,
        showProBadge: true,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/nkerft/design-powerpoint-presentation-keynote-google-slides-just-for-you',
        sellerLink: '/nkerft',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795764/presentation-design-5a.png',
        categoryName: 'presentation_design',
        gigDescription: 'I will create powerpoint presentation pitch deck design',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206082/presentation-design-valentyna-p-6.png',
        userName: 'Valentyna P',
        rating: 4.9,
        reviewsCount: 79,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/piroshka/design-presentation-in-figma-or-powerpoint',
        sellerLink: '/piroshka',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795755/presentation-design-6a.png',
        categoryName: 'presentation_design',
        gigDescription: 'I will create a business presentation design in figma',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206087/software-development-klimt-creations-1.png',
        userName: 'Klimt Creations',
        rating: 5,
        reviewsCount: 8,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/monicaklimt/convert-from-figma-to-webflow-landing-page',
        sellerLink: '/agencies/klimtcreations',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795776/software-development-1a.png',
        categoryName: 'software_development',
        gigDescription: 'Our agency will develop your web app mvp or migrate website to webflow, react, next js',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206071/software-development-andrew-maksakov-2.png',
        userName: 'Andrew Maksakov',
        rating: 4.5,
        reviewsCount: 21,
        showProBadge: true,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink: '/andrisdev/developing-mobile-applications-for-android-ios-and-web',
        sellerLink: '/andrisdev',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795767/software-development-2a.png',
        categoryName: 'software_development',
        gigDescription: 'I will develop the best IOS and android or web application',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206071/software-development-juan-h-3.png',
        userName: 'Juan H',
        rating: 5,
        reviewsCount: 743,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/jhernandezc/customize-your-shopify-theme',
        sellerLink: '/jhernandezc',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795753/software-development-3a.png',
        categoryName: 'software_development',
        gigDescription: 'I will do shopify coding or theme customization',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206074/software-development-devgenius-4.png',
        userName: 'Devgenius',
        rating: 5,
        reviewsCount: 18,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/rexsoftinccom/provide-custom-web-app-software-solutions-for-your-needs',
        sellerLink: '/malikaqib367',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795755/software-development-4a.png',
        categoryName: 'software_development',
        gigDescription:
            'Our agency will develop custom web app software solutions for business or startup from scratch',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206068/software-development-devgenius-5.png',
        userName: 'Devgenius',
        rating: 5,
        reviewsCount: 63,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: true,
        showSellerLevelTwoBadge: true,
        gigLink: '/malikaqib367/do-web-application-and-web-software-development',
        sellerLink: '/malikaqib367',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795769/software-development-5a.png',
        categoryName: 'software_development',
        gigDescription: 'I will develop a web application, be an ai powered software developer, and build saas',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206084/software-development-gabriel-soare-6.png',
        userName: 'Gabriel Soare',
        rating: 5,
        reviewsCount: 110,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink: '/soaregabriel/design-and-develop-a-responsive-website',
        sellerLink: '/soaregabriel',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795760/software-development-6a.png',
        categoryName: 'software_development',
        gigDescription: 'I will design and develop quality website',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206063/website-design-bojan-sandic-1.png',
        userName: 'Bojan Sandic',
        rating: 4.9,
        reviewsCount: 1000,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/skydesigner/design-awesome-website-or-landing-page',
        sellerLink: '/skydesigner',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795752/website-design-1a.png',
        categoryName: 'website_design',
        gigDescription: 'I will design awesome website or landing page',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206076/website-design-marko-b-2.png',
        userName: 'Marko B.',
        rating: 4.9,
        reviewsCount: 526,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/hipinspire/design-creative-and-unique-website',
        sellerLink: '/hipinspire',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795774/website-design-2a.png',
        categoryName: 'website_design',
        gigDescription: 'I will design a creative and unique website',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206066/website-design-kiki-3.png',
        userName: 'Kiki',
        rating: 4.9,
        reviewsCount: 480,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/kianaaz/design-unique-web-and-app-ui-ux-with-prototype',
        sellerLink: '/kianaaz/design-unique-web-and-app-ui-ux-with-prototype',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795761/website-design-3a.png',
        categoryName: 'website_design',
        gigDescription: 'I will do figma website design and UI UX mockup',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206067/website-design-ihor-4.png',
        userName: 'Ihor',
        rating: 4.9,
        reviewsCount: 125,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/ihoryarchuk/design-creative-and-quality-website',
        sellerLink: '/ihoryarchuk',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795754/website-design-4a.png',
        categoryName: 'website_design',
        gigDescription: 'I will design a premium figma website for high conversions',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206076/website-design-dejan-djokovic-5.png',
        userName: 'Dejan Djokovic',
        rating: 5,
        reviewsCount: 12,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/dejandjokovic/design-a-native-mobile-app',
        sellerLink: '/dejandjokovic',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795755/website-design-5a.png',
        categoryName: 'website_design',
        gigDescription: 'I will design a professional website using framer website',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206083/website-design-intoplacedesign-6.png',
        userName: 'IntoPlaceDesign',
        rating: 5,
        reviewsCount: 100,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/marten_eyferth/design-an-interactive-and-3d-animated-webflow-website',
        sellerLink: '/agencies/intoplacedesign',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795753/website-design-6a.png',
        categoryName: 'website_design',
        gigDescription: 'Our agency will design an interactive and 3d animated webflow website',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206061/book-design-marta-1.png',
        userName: 'Marta',
        rating: 5,
        reviewsCount: 250,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/marta_obucina/design-artistic-book-covers-romance-poetry-fantasy-etc',
        sellerLink: '/marta_obucina',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795752/book-design-1a.png',
        categoryName: 'book_design',
        gigDescription: 'I will create artistic fantasy book cover design',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206063/book-design-mickey-chan-2.png',
        userName: 'Mickey Chan',
        rating: 5,
        reviewsCount: 20,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/mickeychan/design-a-book-cover-that-stands-out',
        sellerLink: '/freelancers/mickeychan',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795761/book-design-2a.png',
        categoryName: 'book_design',
        gigDescription: 'I will design a book cover that stands out',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206076/book-design-valeriia-t-3.png',
        userName: 'Valeriia T',
        rating: 5,
        reviewsCount: 20,
        showProBadge: true,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink: '/valeriiaty/design-a-heart-winning-book-or-ebook-cover-for-you',
        sellerLink: '/freelancers/valeriiaty',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795751/book-design-3a.png',
        categoryName: 'book_design',
        gigDescription: 'I will design a heart winning book or ebook cover for you',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7274e19167edb87185b25939efc6ae5c-1753262814039/book-design-anas-j-4.png',
        userName: 'Anas J.',
        rating: 4.8,
        reviewsCount: 473,
        showProBadge: true,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink: '/anas23d/design-kdp-low-content-book-cover-plus-interior',
        sellerLink: '/freelancers/anas23d',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795763/book-design-4a.png',
        categoryName: 'book_design',
        gigDescription: 'I will do a unique book cover design or KDP book cover',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206084/book-design-matteo-g-5.png',
        userName: 'Matteo G.',
        rating: 4.9,
        reviewsCount: 63,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/weirdwiring/create-a-vector-art-book-cover-design',
        sellerLink: '/freelancers/weirdwiring',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795754/book-design-5a.png',
        categoryName: 'book_design',
        gigDescription: 'I will design a minimal book cover',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206079/book-design-barbara-borko-6.png',
        userName: 'Barbara Borko',
        rating: 4.9,
        reviewsCount: 9,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/bbdesignstudio/design-an-eye-catching-book-cover',
        sellerLink: '/freelancers/bbdesignstudio',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795762/book-design-6a.png',
        categoryName: 'book_design',
        gigDescription: 'I will design a captivating book cover',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7274e19167edb87185b25939efc6ae5c-1753262825093/ai-development-rilloo-1.png',
        userName: 'Rilloo',
        rating: 4.9,
        reviewsCount: 9,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/dor1010/develop-ai-chatbot-with-chatgpt-llm-openai-langchain-pincone',
        sellerLink: '/agencies/rilloo',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795761/ai-development-1a.png',
        categoryName: 'ai_development',
        gigDescription: 'Our agency will develop ai chatbot with llm, rag, chatgpt, langchain, gemini',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206065/ai-development-anthony-charles-2.png',
        userName: 'Anthony Charles',
        rating: 5,
        reviewsCount: 67,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/anthonycharl227/develop-a-website-from-scratch',
        sellerLink: '/anthonycharl227',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795751/ai-development-2a.png',
        categoryName: 'ai_development',
        gigDescription: 'I will build your ai app, mvp or saas product',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206077/ai-development-muhammad-osama-3.png',
        userName: 'Muhammad Osama',
        rating: 5,
        reviewsCount: 30,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink: '/imcodezeroweb/develop-your-website-and-dashboard-as-full-stack-web-developer',
        sellerLink: '/imcodezeroweb',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795769/ai-development-3a.png',
        categoryName: 'ai_development',
        gigDescription: 'I will develop custom web application, ai website dashboard as full stack web developer',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206074/ai-development-ryan-4.png',
        userName: 'Ryan',
        rating: 5,
        reviewsCount: 354,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/ryansaud/create-ai-powered-web-dashboards-and-reporting-tools',
        sellerLink: '/ryansaud',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795757/ai-development-4a.png',
        categoryName: 'ai_development',
        gigDescription: 'I will create ai powered web dashboards and reporting tools',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206072/ai-development-shovon-5.png',
        userName: 'Shovon',
        rating: 5,
        reviewsCount: 336,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: true,
        showSellerLevelTwoBadge: true,
        gigLink: '/code_craf/develop-ai-chatgpt-app-ai-saas-app-application-ai-chatbot-llm-ai-software',
        sellerLink: '/code_craf',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795750/ai-development-5a.png',
        categoryName: 'ai_development',
        gigDescription: 'I will develop chatgpt ai mobile app or website ai saas app ai chatbot ai software',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206060/ai-development-siraj-s-6.png',
        userName: 'Siraj.s',
        rating: 4.8,
        reviewsCount: 19,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink: '/sirajsiyabudeen/create-a-ai-powered-web-app-end-to-end-on-mern',
        sellerLink: '/sirajsiyabudeen',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795770/ai-development-6a.png',
        categoryName: 'ai_development',
        gigDescription: 'I will build ai powered web apps',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206087/ugc-videos-marshall-1.png',
        userName: 'Marshall',
        rating: 4.9,
        reviewsCount: 97,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/mlvoiceover/create-a-ugc-spokesperson-video-ad-for-your-business-or-brand-male-creator',
        sellerLink: '/mlvoiceover',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795759/ugc-videos-1a.png',
        categoryName: 'ugc_videos',
        gigDescription: 'I will create a ugc spokesperson video ad male content creator',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206080/ugc-videos-allie-madison-2.png',
        userName: 'Allie Madison',
        rating: 4.9,
        reviewsCount: 5500,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/alliemadison12/make-a-video-about-what-interests-me',
        sellerLink: '/alliemadison12',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795773/ugc-videos-2a.png',
        categoryName: 'ugc_videos',
        gigDescription: 'I will make a promotional spokesperson video',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206063/ugc-videos-zoe-w-3.png',
        userName: 'Zoe W.',
        rating: 4.9,
        reviewsCount: 296,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/zoewynns/create-a-tiktok-style-ugc-ad-for-your-brand-or-product',
        sellerLink: '/zoewynns',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795752/ugc-videos-3a.png',
        categoryName: 'ugc_videos',
        gigDescription: 'I will create a tiktok style ugc video ad for your brand or product',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206066/ugc-videos-jenna-edwards-4.png',
        userName: 'Jenna Edwards',
        rating: 5,
        reviewsCount: 101,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/jennagedwards/be-your-photo-or-video-model',
        sellerLink: '/jennagedwards',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795771/ugc-videos-4a.png',
        categoryName: 'ugc_videos',
        gigDescription: 'I will create professional tiktok ugc video ads for product or app',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206063/ugc-videos-nate-flake-5.png',
        userName: 'Nate Flake',
        rating: 5,
        reviewsCount: 189,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/nateflake/create-ugc-video-ads-for-tiktok-instagram-or-facebook',
        sellerLink: '/nateflake',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795773/ugc-videos-5a.png',
        categoryName: 'ugc_videos',
        gigDescription: 'I will create male ugc spokesperson videos for your brand',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206081/ugc-videos-marina-monaco-6.png',
        userName: 'Marina Monaco',
        rating: 5,
        reviewsCount: 52,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/minnies104/create-ugc-tiktok-or-reels-in-german',
        sellerLink: '/minnies104',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795760/ugc-videos-6a.png',
        categoryName: 'ugc_videos',
        gigDescription: 'I will create ugc tiktok or reels in german',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206083/resume-writing-alex-r-1.png',
        userName: 'Alex R.',
        rating: 5,
        reviewsCount: 1200,
        showProBadge: true,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/alexlouiserose/use-my-xp-as-a-startup-tech-recruiter-to-review-your-resume',
        sellerLink: '/alexlouiserose',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795766/resume-writing-1a.png',
        categoryName: 'resume_writing',
        gigDescription: 'I will edit your resume using my recruiting expertise',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206081/resume-writing-john-2.png',
        userName: 'John',
        rating: 4.9,
        reviewsCount: 320,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/resumeplus04/get-you-your-dream-job-by-professional-cv-resume-and-cover-letter-writing',
        sellerLink: '/resumeplus04',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795757/resume-writing-2a.png',
        categoryName: 'resume_writing',
        gigDescription: 'I will offer professional resume writing, resume and cover letter, linkedin',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206081/resume-writing-jeff-3.png',
        userName: 'Jeff',
        rating: 4.9,
        reviewsCount: 405,
        showProBadge: true,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/jytliu/rewrite-your-software-engineering-resume-and-cover-letter',
        sellerLink: '/jytliu',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795765/resume-writing-3a.png',
        categoryName: 'resume_writing',
        gigDescription: 'I will edit your resume, cover letter and linkedin',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206075/resume-writing-emily-4.png',
        userName: 'Emily',
        rating: 4.6,
        reviewsCount: 153,
        showProBadge: true,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/emandapen/rebrand-your-resume-cover-letter-and-linkedin-profile',
        sellerLink: '/emandapen',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795763/resume-writing-4a.png',
        categoryName: 'resume_writing',
        gigDescription: 'I will write your executive level resume',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206071/resume-writing-richard-lambert-5.png',
        userName: 'Richard Lambert',
        rating: 4.8,
        reviewsCount: 24300,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/lambertcv/create-edit-and-design-your-cv-cover-letter-and-linkedin-profile',
        sellerLink: '/lambertcv',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795752/resume-writing-5a.png',
        categoryName: 'resume_writing',
        gigDescription: 'I will write and upgrade your resume, cv, cover letter, linkedin',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a65c04690942fb7eca117947d5ab621b-1753260206074/resume-writing-charmaine-pocek-6.png',
        userName: 'Charmaine Pocek',
        rating: 4.8,
        reviewsCount: 14200,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink: '/boomsa/create-a-new-resume-or-cover-letter-to-ensure-an-interview-1200-feedback',
        sellerLink: '/boomsa',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/8a7fcb7d324f1eeaa35c0b8311b70d3e-1753109795759/resume-writing-6a.png',
        categoryName: 'resume_writing',
        gigDescription: 'I will rewrite and edit your tech resume as a faang software engineer',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9a61dd5c48004b17c9b4a19eda5aea84-1756878145750/Gig%20image_Deshan.png',
        userName: 'Deshan',
        rating: 5,
        reviewsCount: 166,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink:
            'https://www.fiverr.com/deshan1996/create-3d-floor-plans-with-rendering?context_referrer=seller_page&ref_ctx_id=fb865086c3b5403dbe3419ea6569f786&pckg_id=1&pos=1&imp_id=dd439dae-9f00-4f65-9927-dc7e7b3f91ca',
        sellerLink:
            'https://www.fiverr.com/deshan1996?source=gig_page&gigs=slug%3Acreate-3d-floor-plans-with-rendering%2Cpckg_id%3A1',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/51e9c0722e9811d55bed6ab1869f99cc-1756878390963/Avatar%20image_Deshan.png',
        categoryName: 'architecture_interior_design',
        gigDescription: 'I will create 3d and 2d floor plans with rendering',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9a61dd5c48004b17c9b4a19eda5aea84-1756878145754/Gig%20image_Mickey%20Chan.png',
        userName: 'Mickey Chan',
        rating: 4.9,
        reviewsCount: 1900,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink:
            'https://www.fiverr.com/lehuy_design/model-render-photoshop?context_referrer=seller_page&ref_ctx_id=72bd07ea41004913a5874f5ecf08acce&pckg_id=1&pos=1&imp_id=f7575cf4-1d74-4228-96fb-e7b8d899fae9',
        sellerLink:
            'https://www.fiverr.com/lehuy_design?source=gig_page&gigs=slug%3Amodel-render-photoshop%2Cpckg_id%3A1',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/51e9c0722e9811d55bed6ab1869f99cc-1756878390972/Avatar%20image_Mickey%20Chan.png',
        categoryName: 'architecture_interior_design',
        gigDescription: 'I will create 3d model and render exterior, interior, 3d floor plan',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9a61dd5c48004b17c9b4a19eda5aea84-1756878145771/Gig%20image_Tran%20L.png',
        userName: 'Tran L',
        rating: 5,
        reviewsCount: 312,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink:
            'https://www.fiverr.com/lifeanddesign/make-3d-sketchup-model-and-rendering?context_referrer=seller_page&ref_ctx_id=8125d2366fb94053b16c315027230766&pckg_id=1&pos=1&imp_id=719fcbd7-152a-49df-bb53-81373b79c1be',
        sellerLink:
            'https://www.fiverr.com/lifeanddesign?source=gig_page&gigs=slug%3Amake-3d-sketchup-model-and-rendering%2Cpckg_id%3A1',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/51e9c0722e9811d55bed6ab1869f99cc-1756878390960/Avatar%20image_Tran%20L.png',
        categoryName: 'architecture_interior_design',
        gigDescription: 'I will make architectural 3d sketchup modeling and rendering',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9a61dd5c48004b17c9b4a19eda5aea84-1756878145769/Gig%20image_Tran%20Thanh%20Binh.png',
        userName: 'Tran Thanh Binh',
        rating: 5,
        reviewsCount: 1700,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink:
            'https://www.fiverr.com/design_house/creates-3d-floor-plan-the-fastest-best-for-you?context_referrer=seller_page&ref_ctx_id=f6135eff259446a6b1a700424e840083&pckg_id=1&pos=1&imp_id=78643aa4-c7ab-475c-9f9a-77c60a573d0f',
        sellerLink:
            'https://www.fiverr.com/design_house/creates-3d-floor-plan-the-fastest-best-for-you?context_referrer=seller_page&ref_ctx_id=f6135eff259446a6b1a700424e840083&pckg_id=1&pos=1&imp_id=78643aa4-c7ab-475c-9f9a-77c60a573d0f',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/51e9c0722e9811d55bed6ab1869f99cc-1756878390968/Avatar%20image_Tran%20Thanh%20Binh.png',
        categoryName: 'architecture_interior_design',
        gigDescription: 'I will create 3d render realistic 3d floor plan , exterior or interior',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9a61dd5c48004b17c9b4a19eda5aea84-1756878145756/Gig%20image_Mohamed%20Samara.png',
        userName: 'Mohamed Samara',
        rating: 4.7,
        reviewsCount: 336,
        showProBadge: false,
        showTopRatedBadge: true,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: false,
        gigLink:
            'https://www.fiverr.com/msamara/draw-as-built-drawing-to-existing-building?context_referrer=seller_page&ref_ctx_id=2a5440126eab4a18abf83b5022d0852e&pckg_id=1&pos=1&seller_online=true&imp_id=dad662fe-fe62-40c4-9dd1-4cbe98b148dd',
        sellerLink:
            'https://www.fiverr.com/msamara?source=gig_page&gigs=slug%3Adraw-as-built-drawing-to-existing-building%2Cpckg_id%3A1',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/51e9c0722e9811d55bed6ab1869f99cc-1756878390965/Avatar%20image_Mohamed%20Samara.png',
        categoryName: 'architecture_interior_design',
        gigDescription: 'I will draw permitting architectural blueprints',
    },
    {
        coverImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9a61dd5c48004b17c9b4a19eda5aea84-1756878145751/Gig%20image_Atelje%20Studio.png',
        userName: 'Atelje Studio',
        rating: 5,
        reviewsCount: 234,
        showProBadge: false,
        showTopRatedBadge: false,
        showFiverrChoiceBadge: false,
        showSellerLevelTwoBadge: true,
        gigLink:
            'https://www.fiverr.com/ateljestudio/make-3d-interior-from-your-floorplan?context_referrer=seller_page&ref_ctx_id=49b0bd3376ba4f44a8e18871544079cb&pckg_id=1&pos=2&imp_id=ab0f0ae0-24c3-4915-9221-b074f1d8e814',
        sellerLink:
            'https://www.fiverr.com/ateljestudio/make-3d-interior-from-your-floorplan?context_referrer=seller_page&ref_ctx_id=49b0bd3376ba4f44a8e18871544079cb&pckg_id=1&pos=2&imp_id=ab0f0ae0-24c3-4915-9221-b074f1d8e814',
        avatarImage:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/51e9c0722e9811d55bed6ab1869f99cc-1756878390958/Avatar%20image_Atelje%20Studio.png',
        categoryName: 'architecture_interior_design',
        gigDescription: 'I will make 3d floorplan from your drawing',
    },
];
